/**
 * Created by wwei on 2018-10-25.
 */

import React, { Component } from 'react';
import request from 'superagent';
import { Button, Input, Icon, Form, Checkbox, Radio } from 'antd';
import NotificationManager from '../../commons/CustomNotificationManager.js';
import { getUrl, ROLES } from "../../commons/CommonUtils.js";
import Constants from '../../commons/Constants.js';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

const ROLE_OPTIONS = [
    { label: ROLES.DEVICE_ADMIN.label, value: ROLES.DEVICE_ADMIN.value },
    { label: ROLES.DEVICE_OPERATOR.label, value: ROLES.DEVICE_OPERATOR.value },
    { label: ROLES.ENTERPRISE_ADMIN.label, value: ROLES.ENTERPRISE_ADMIN.value },
    { label: ROLES.LICENSE_ADMIN.label, value: ROLES.LICENSE_ADMIN.value },
    { label: ROLES.OTD_ADMIN.label, value: ROLES.OTD_ADMIN.value },
    { label: ROLES.PDMSSP_ADMIN.label, value: ROLES.PDMSSP_ADMIN.value },
    { label: ROLES.USER_ADMIN.label, value: ROLES.USER_ADMIN.value }
];

class TenantAddUserForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saving: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tenantId && this.props.tenantId !== nextProps.tenantId) {
            this.reset();
        }
    }

    addUser = () => {
        this.props.form.validateFields((err, newUser) => {
            if (!err) {
                this.setState({ saving: true });
                if (newUser.roles.indexOf("PDMSSPAdmin") !== -1
                    && newUser.roles.indexOf("PDMSSPUser") === -1) {
                    newUser.roles.push("PDMSSPUser");
                }

                newUser["url"] = getUrl(Constants.Service.localUser, "/user", this.props.tenantId);

                return request.post("/api/createUser")
                    .send(newUser)
                    .withCredentials()
                    .end((error, response) => {
                        this.setState({ saving: false });
                        if (error) {
                            const status = error.status;
                            if (403 === status) {
                                console.error("The user does not have the necessary permissions");
                                NotificationManager.error("The user does not have the necessary permissions");
                            } else if (409 === status) {
                                console.error("There was a conflict when creating user (e.g., email-id already in use");
                                NotificationManager.error("A user with that email address already exists.");
                            } else if (412 === status) {
                                console.error("The email-domain does not match any existing tenant");
                                NotificationManager.error("The email-domain does not match any existing tenant/Guest User does not exist in Home Tenant.");
                            } else {
                                console.error("Failed to add user.", error);
                                NotificationManager.error("Failed to add new user.");
                            }
                        } else {
                            NotificationManager.success("Succeed to add the user.");
                            this.reset();
                        }
                    });
            }
        });
    }

    reset = () => {
        this.props.form.resetFields();
        this.emailInput.focus();
    }

    render() {
        const { saving } = this.state;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { xs: {span: 24}, sm: {span: 6} },
            wrapperCol: { xs: {span: 24}, sm: {span: 18} }
        };

        return (
            <div className="tenant-user-form">
                <Form>
                    <FormItem {...formItemLayout} label="Email Address">
                        {getFieldDecorator("email", {
                            rules: [
                                {required: true, message: "This field is required"},
                                {type: "email", message: "Invalid email address."}
                            ]
                        })(
                            <Input
                                ref={input => this.emailInput = input}
                                autoFocus maxLength="64"/>
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="Roles">
                        {getFieldDecorator("roles", {
                            initialValue: [ROLES.DEVICE_ADMIN.value, ROLES.DEVICE_OPERATOR.value,
                                ROLES.ENTERPRISE_ADMIN.value, ROLES.LICENSE_ADMIN.value,
                                ROLES.OTD_ADMIN.value, ROLES.PDMSSP_ADMIN.value,
                                ROLES.USER_ADMIN.value],
                            rules: [{type: "array"}]
                        })(<CheckboxGroup options={ ROLE_OPTIONS }/>)}
                    </FormItem>

                    <div className="ant-modal-footer" style={{ paddingLeft: 0 }} >
                        <div className="col-lg-8" style={{ textAlign: "left", padding: 0 }} >
                            <Button key="submit" type="primary" size="large" loading={saving} onClick={this.addUser} >
                                Save
                            </Button>
                            <Button key="cancel" size="large" onClick={this.reset} disabled={saving} >
                                Clear
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        )
    }

}

const TenantAddUser = Form.create()(TenantAddUserForm);
export default TenantAddUser;


// WEBPACK FOOTER //
// ./src/modules/tenants/TenantAddUser.js